import { stepIds, stepTaggingNames } from './stepIds';
import { STRING_KEYS } from '../localizedStrings';

export const emptyStep = {
  name: 'Inicio',
  id: stepIds.initial,
  searchId: stepIds.initial,
  path: '',
  isGhostStep: true,
  conditions: [],
  taggingName: stepTaggingNames.initial,
};

export const afterSaleParentProductSelectorStep = {
  name: STRING_KEYS.stepTitles.afterSaleParentProductSelector,
  id: stepIds.afterSaleParentProductSelector,
  searchId: stepIds.afterSaleParentProductSelector,
  path: '/seleccionar-producto-padre-post-venta',
  conditions: ['afterSaleParentProductsToSelectRequired'],
  taggingName: stepTaggingNames.afterSaleParentProductSelector,
};

export const obdResidenceErrorStep = {
  name: STRING_KEYS.stepTitles.obdResidenceError,
  id: stepIds.obdResidenceError,
  searchId: stepIds.obdResidenceError,
  path: '/error-residencia',
  conditions: ['isThereOBDResidenceError'],
  taggingName: stepTaggingNames.obdResidenceError,
  isErrorStep: true,
  isGhostStep: true,
};

export const obdErrorStep = {
  name: STRING_KEYS.stepTitles.obdError,
  id: stepIds.obdError,
  searchId: stepIds.obdError,
  path: '/error-contacto',
  conditions: ['isThereOBDError'],
  taggingName: stepTaggingNames.obdError,
  isErrorStep: true,
  isGhostStep: true,
};

export const personalDataStep = {
  name: STRING_KEYS.stepTitles.personalData,
  id: stepIds.personalData,
  searchId: stepIds.personalData,
  path: '/datos-personales',
  conditions: [
    'clientInfoIsIncomplete',
  ],
  blockedByAPI: true,
  isPersonalDataStep: true,
  taggingName: stepTaggingNames.personalData,
  hideShoppingCart: true,
  hideTitleIfProductOfferingChanged: true,
};

export const personalDataStepInitial = {
  name: STRING_KEYS.stepTitles.personalData,
  id: stepIds.personalDataInitial,
  searchId: stepIds.personalDataInitial,
  path: '/datos-personales',
  conditions: [
    'clientInfoIsIncomplete',
  ],
  blockedByAPI: true,
  taggingName: stepTaggingNames.personalData,
  hideShoppingCart: true,
};

export const personalDataStepWithoutInitCQ = {
  name: STRING_KEYS.stepTitles.personalData,
  id: stepIds.personalDataStepWithoutInitCQ,
  searchId: stepIds.personalDataStepWithoutInitCQ,
  path: '/datos-personales',
  conditions: [
    'clientInfoIsIncomplete',
  ],
  blockedByAPI: true,
  isPersonalDataStep: true,
  taggingName: stepTaggingNames.personalDataStepWithoutInitCQ,
  hideShoppingCart: true,
};

export const productOfferingToBuyChanged = {
  name: STRING_KEYS.stepTitles.productOfferingToBuyChanged,
  id: stepIds.productOfferingToBuyChanged,
  searchId: stepIds.productOfferingToBuyChanged,
  path: '/producto-modificado',
  conditions: [
    'productOfferingToBuyChanged',
  ],
  taggingName: stepTaggingNames.productOfferingToBuyChanged,
  hideShoppingCart: true,
};

export const permanentResidenceStep = { // TODO BORRAR? NO SE PINTA NUNCA. VER CON HECTOR
  name: STRING_KEYS.stepTitles.permanentResidence,
  id: stepIds.permanentResidence,
  searchId: stepIds.permanentResidence,
  path: '/domicilio',
  conditions: [
    'permanentResidenceRequired',
  ],
  taggingName: stepTaggingNames.permanentResidence,
};

export const installationStep = {
  name: STRING_KEYS.stepTitles.installation,
  id: stepIds.installation,
  searchId: stepIds.installation,
  path: '/instalacion',
  conditions: [
    'shouldShowInstallationStep',
  ],
  taggingName: stepTaggingNames.installation,
};

export const forcedInstallationStep = {
  name: STRING_KEYS.stepTitles.installation,
  id: stepIds.installation,
  searchId: stepIds.installation,
  path: '/instalacion',
  conditions: [
    'isMyProductsLoaded',
  ],
  taggingName: stepTaggingNames.installation,
};

export const selectParentProductStep = {
  name: STRING_KEYS.stepTitles.selectParentProduct,
  id: stepIds.selectParentProduct,
  searchId: stepIds.selectParentProduct,
  path: '/seleccionar-producto-padre',
  conditions: [
    'parentProductsToSelectRequired',
  ],
  taggingName: stepTaggingNames.selectParentProduct,
};

export const mainActionStep = {
  name: STRING_KEYS.stepTitles.mainAction,
  id: stepIds.mainAction,
  searchId: stepIds.mainAction,
  path: '/accion-principal',
  conditions: [
    'mainActionRequired',
  ],
  taggingName: stepTaggingNames.mainAction,
};

export const mobileSecondaryActionStep = {
  name: STRING_KEYS.stepTitles.mobileSecondaryAction,
  id: stepIds.mobileSecondaryAction,
  searchId: stepIds.mobileSecondaryAction,
  path: '/accion-secundaria-movil',
  conditions: [
    'mobileSecondaryActionRequired',
  ],
  taggingName: stepTaggingNames.mobileSecondaryAction,
};

export const landLineSecondaryActionStep = {
  name: STRING_KEYS.stepTitles.landLineSecondaryAction,
  id: stepIds.landLineSecondaryAction,
  searchId: stepIds.landLineSecondaryAction,
  path: '/accion-secundaria-fijo',
  conditions: [
    'landLineSecondaryActionRequired',
  ],
  taggingName: stepTaggingNames.landLineSecondaryAction,
};

export const numberOfSimsStep = {
  name: STRING_KEYS.stepTitles.numberOfSims,
  id: stepIds.numberOfSims,
  searchId: stepIds.numberOfSims,
  path: '/numero-de-sims',
  conditions: [
    'numberOfMultiSimRequired',
  ],
  taggingName: stepTaggingNames.numberOfSims,
};

export const alreadyOwnedProductsChoicesStep = {
  name: STRING_KEYS.stepTitles.alreadyOwnedProductsChoices,
  id: stepIds.alreadyOwnedProductsChoices,
  searchId: stepIds.alreadyOwnedProductsChoices,
  path: '/eleccion-necesaria',
  conditions: [
    'alreadyOwnedProductsChoicesRequired',
  ],
  taggingName: stepTaggingNames.alreadyOwnedProductsChoices,
};

export const portabilityOTPStep = {
  name: STRING_KEYS.stepTitles.portabilityOTP,
  id: stepIds.portabilityOTP,
  searchId: stepIds.portabilityOTP,
  path: '/otp-portabilidad',
  conditions: [
    'portabilityOTPRequired',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.portabilityOTP,
};

export const commitmentStep = {
  name: STRING_KEYS.stepTitles.commitment,
  id: stepIds.commitment,
  searchId: stepIds.commitment,
  path: '/plazos',
  conditions: [
    'commitmentSelectionRequired',
  ],
  taggingName: stepTaggingNames.commitment,
};

export const ppipStep = {
  name: STRING_KEYS.stepTitles.ppip,
  id: stepIds.ppip,
  searchId: stepIds.ppip,
  path: '/linea-provisional',
  conditions: [
    'isPpipAvailableCondition',
  ],
  taggingName: stepTaggingNames.ppip,
};

export const deviceInstallationStep = {
  name: STRING_KEYS.stepTitles.deviceInstallation,
  id: stepIds.deviceInstallation,
  searchId: stepIds.deviceInstallation,
  path: '/instalacion-dispositivo',
  conditions: [
    'isDeviceInstallationChoiceRequired',
  ],
  taggingName: stepTaggingNames.deviceInstallation,
};

export const shipmentStep = {
  name: STRING_KEYS.stepTitles.shipment,
  id: stepIds.shipment,
  searchId: stepIds.shipment,
  path: '/direccion-envio',
  conditions: [
    'isHomeShippingRequired',
  ],
  taggingName: stepTaggingNames.shipment,
};

export const paymentStep = {
  name: STRING_KEYS.stepTitles.payment,
  id: stepIds.payment,
  searchId: stepIds.payment,
  path: '/forma-pago',
  conditions: [
    'isCustomerAccountRequired',
  ],
  taggingName: stepTaggingNames.payment,
};

export const riskStep = {
  name: '',
  id: stepIds.risk,
  searchId: stepIds.risk,
  path: '/problema',
  conditions: [
    'isRiskStepRequired',
  ],
  isGhostStep: true,
  isErrorStep: true,
  taggingName: stepTaggingNames.risk,
};

export const scoringStep = {
  name: STRING_KEYS.stepTitles.scoring,
  id: stepIds.scoring,
  searchId: stepIds.scoring,
  path: '/datos-financieros',
  conditions: [
    'scoringInfoRequired',
  ],
  taggingName: stepTaggingNames.scoring,
};

export const summaryStep = {
  name: '',
  id: stepIds.summary,
  searchId: stepIds.summary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
    'areLegalTermsAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const manualSummaryStep = {
  name: '',
  id: stepIds.manualSummary,
  searchId: stepIds.manualSummary,
  path: '/resumen',
  conditions: [
    'isClientInfoRead',
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const manualRenewalSummaryStep = {
  name: '',
  id: stepIds.manualRenewalSummary,
  searchId: stepIds.manualRenewalSummary,
  path: '/resumen',
  conditions: [
    'isClientInfoRead',
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const oneClickSummaryStep = {
  name: '',
  id: stepIds.oneClickSummary,
  searchId: stepIds.oneClickSummary,
  path: '/resumen',
  conditions: [
    'isClientInfoRead',
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
  isCompactSummary: true,
};

export const manualNewClientSummaryStep = {
  name: '',
  id: stepIds.manualNewClientSummary,
  searchId: stepIds.manualNewClientSummary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const packSummaryStep = {
  name: '',
  id: stepIds.packSummary,
  searchId: stepIds.packSummary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
    'areLegalTermsAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const VTLSummaryStep = {
  name: '',
  id: stepIds.vtlSummary,
  searchId: stepIds.vtlSummary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const VTLNewClientSummary = {
  name: '',
  id: stepIds.vtlNewClientSummary,
  searchId: stepIds.vtlNewClientSummary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const DuoNewClientSummary = {
  name: '',
  id: stepIds.duoNewClientSummary,
  searchId: stepIds.duoNewClientSummary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const deviceSummaryStep = {
  name: '',
  id: stepIds.deviceSummary,
  searchId: stepIds.deviceSummary,
  path: '/resumen',
  conditions: [
    'arePricesAvailable',
  ],
  isSummaryStep: true,
  taggingName: stepTaggingNames.summary,
};

export const VTLCardPaymentStep = {
  name: '',
  id: stepIds.vtlCardPayment,
  searchId: stepIds.vtlCardPayment,
  path: '/tarjeta',
  conditions: [
    'isCardPayment',
  ],
  isSummaryStep: false,
  taggingName: stepTaggingNames.card,
};

export const confirmationStep = {
  name: '',
  id: stepIds.confirmation,
  searchId: stepIds.confirmation,
  path: '/confirmacion',
  conditions: [
    'isConfirmationAvailable',
  ],
  isConfirmationStep: true,
  taggingName: stepTaggingNames.confirmation,
};

export const DeviceConfirmationStep = {
  name: '',
  id: stepIds.confirmation,
  searchId: stepIds.confirmation,
  path: '/confirmacion',
  conditions: [
    'neverShowStep',
  ],
  isConfirmationStep: true,
  taggingName: stepTaggingNames.confirmation,
};

export const chooseNumberOTPStep = {
  name: STRING_KEYS.stepTitles.chooseNumberOTP,
  id: stepIds.chooseNumberOTP,
  searchId: stepIds.chooseNumberOTP,
  path: '/elegir-otp',
  conditions: [
    'areThereMultipleLinesForOTP',
    'isDeviceOrPackSummaryConfirmed',
  ],
  isConfirmationStep: false,
  taggingName: stepTaggingNames.chooseNumberOTP,
};

export const signatureStep = {
  name: '',
  id: stepIds.signature,
  searchId: stepIds.signature,
  path: '/firma',
  conditions: [
    'isDeviceOrPackSummaryConfirmed',
    'isSignatureUrlOTP',
  ],
  isConfirmationStep: false,
  hideShoppingCart: true,
  taggingName: stepTaggingNames.signature,
  fullWidthStep: true,
  hideHeaderAndTitle: true,
  hideTelefonicaBar: true,
};

export const genericSignatureStep = {
  name: '',
  id: stepIds.genericSignature,
  searchId: stepIds.genericSignature,
  path: '/firma',
  conditions: [
    'isDeviceOrPackSummaryConfirmed',
    'isSignatureUrlOTP',
  ],
  isConfirmationStep: false,
  hideShoppingCart: true,
  taggingName: stepTaggingNames.signature,
  fullWidthStep: true,
  hideHeaderAndTitle: true,
  hideTelefonicaBar: true,
};

export const creditLimitErrorStep = {
  name: STRING_KEYS.stepTitles.creditLimitError,
  id: stepIds.creditLimitError,
  searchId: stepIds.creditLimitError,
  path: '/error-lc',
  conditions: ['isClientWithoutAvailableCredit'],
  taggingName: stepTaggingNames.creditLimitError,
  isErrorStep: true,
  isGhostStep: true,
};

export const riskErrorStep = {
  name: STRING_KEYS.stepTitles.riskError,
  id: stepIds.riskError,
  searchId: stepIds.riskError,
  path: '/error-fr',
  conditions: ['isClientWithUnknownRisk'],
  taggingName: stepTaggingNames.riskError,
  isErrorStep: true,
  isGhostStep: true,
};

export const debtErrorStep = {
  name: STRING_KEYS.stepTitles.debtError,
  id: stepIds.debtError,
  searchId: stepIds.debtError,
  path: '/error-db',
  conditions: ['isClientWithDebt'],
  taggingName: stepTaggingNames.debtError,
  isErrorStep: true,
  isGhostStep: true,
};
